import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useLanguage, stripLocaleFromPath, buildLocalePath } from 'i18n/LanguageContext';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from 'i18n';

const SITE_URL = 'https://www.inrange.io';

const buildAbsoluteUrl = (path, language) => {
    const localePath = buildLocalePath(path, language);
    if (localePath === '/') return `${SITE_URL}/`;
    return `${SITE_URL}${localePath}`;
};

const SEO = ({ title, description, path }) => {
    const { language } = useLanguage();
    const location = useLocation();
    const canonicalPath = path || stripLocaleFromPath(location.pathname);

    return (
        <Helmet>
            <html lang={language} />
            {title && <title>{title}</title>}
            {description && <meta name="description" content={description} />}
            <link rel="canonical" href={buildAbsoluteUrl(canonicalPath, language)} />
            {SUPPORTED_LANGUAGES.map((lang) => (
                <link
                    key={lang}
                    rel="alternate"
                    hrefLang={lang}
                    href={buildAbsoluteUrl(canonicalPath, lang)}
                />
            ))}
            <link rel="alternate" hrefLang="x-default" href={buildAbsoluteUrl(canonicalPath, DEFAULT_LANGUAGE)} />
        </Helmet>
    );
};

export default SEO;
